import {setMaxScale} from '../utils/utils'
import NP from 'number-precision'

/**
 * 将数字转为科学计数(可传入参数截取几位小数[是截取不是四舍五入])
 * @param num
 * @param scale
 * @returns {string|*}
 */
export function toThousandFilterWithScale (num, scale = 2) {
  if (!+num) return num
  const scaleNum = setMaxScale(num, scale, true)
  return scaleNum.toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * 将虚拟币金额转为带8为小数
 * @param num
 * @returns {string|*}
 */
export function toThousandFilterVc (num) {
  // return toThousandFilterWithScale(num, 8)
  // return setMaxScale(num, 8, false)
  if (!+num) return num
  return num.toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
  // return num
}
/**
 * 将虚拟币金额转为带20为小数
 * @param num
 * @returns {string|*}
 */
export function toThousandFilterVcBalance (num) {
  return setMaxScale(num, 10, false)
  // return num
}

/**
 * 简化金额显示排序(中文)
 * @param num
 * @returns {string|*}
 */
export function formatVCAmountZh (num) {
  if (num < 0) {
    return '0'
  } else if (num > 0 && num <= 10000) {
    return toThousandFilterWithScale(NP.divide(num, 1000)) + '仟'
  } else if (num > 10000 && num <= 10000000) {
    return toThousandFilterWithScale(NP.divide(num, 10000)) + '万'
  } else if (num > 10000000 && num <= 1000000000000) {
    return toThousandFilterWithScale(NP.divide(num, 100000000)) + '亿'
  } else if (num > 1000000000000 && num <= 1000000000000000) {
    return toThousandFilterWithScale(NP.divide(num, 1000000000000)) + '万亿'
  }
}

/**
 * 简化金额显示排序(英文)
 * @param num
 * @param digits
 * @returns {string|*}
 */
export function formatVCAmountEn (num, digits) {
  const si = [
    { value: 1, symbol: '' },
    { value: 1E3, symbol: 'K' },
    { value: 1E6, symbol: 'M' },
    { value: 1E9, symbol: 'G' },
    { value: 1E12, symbol: 'T' },
    { value: 1E15, symbol: 'P' },
    { value: 1E18, symbol: 'E' }
  ]
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
  let i
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break
    }
  }
  return (num / si[i].value).toFixed(digits).replace(rx, '$1') + si[i].symbol
}

/***
 * 将科学计数法转换成常规数字
 * @param num
 * @returns {string|*}
 */
export function getFullNum (num) {
  // 处理非数字
  if (isNaN(num)) { return num };

  // 处理不需要转换的数字
  const str = '' + num
  if (!/e/i.test(str)) { return num };

  return (num).toFixed(18).replace(/\.?0+$/, '')
}

/* export function transferToNumber (inputNumber) {
  if (isNaN(inputNumber)) {
    return inputNumber
  }
  inputNumber = '' + inputNumber
  inputNumber = parseFloat(inputNumber)
  let eFormat = inputNumber.toExponential() // 转换为标准的科学计数法形式（字符串）
  let tmpArray = eFormat.match(/\d(?:\.(\d*))?e([+-]\d+)/) // 分离出小数值和指数值
  return inputNumber.toFixed(Math.max(0, (tmpArray[1] || '').length - tmpArray[2]))
} */



// WEBPACK FOOTER //
// ./src/filters/index.js